import React, { useState, useEffect, useRef } from "react";
import FilterData from "./filterData";
import ShowData from "./showData";
import { Formik, Form, ErrorMessage, getIn } from "formik";
import * as Yup from "yup";
import { connect } from "react-redux";
import { InsertData2 } from "../../../Service/service.goods";
import { swalSuccess, swalError } from "../../../Components/sweetAlert";
import { GetData } from "../../../Service/service.goods";
import { useTranslation } from "react-i18next";
import Modal from "react-bootstrap/Modal";
import { UpdateDimensions } from "../../../Service/service.goods";
import {calculatedPrice as calculatedPriceAPI, CheckDimensions} from "../../../Service/service.Parcels";
import { Tab, Tabs } from 'react-bootstrap';
import {ShowEmpService} from "../../../Service/service.Employee";
import { Typeahead } from 'react-bootstrap-typeahead';

function SixWheelScan(props) {
  const { user } = props;
  // const inputs = useRef([]);
  const inputsRef = useRef([]);
  
  const dimensionSchema = Yup.object().shape({
    weight: Yup.number()
      .typeError('Weight must be a number')
      .positive('Weight must be greater than 0')
      .required('Weight is required'),
    box_length: Yup.number()
      .typeError('Length must be a number')
      .positive('Length must be greater than 0')
      .required('Length is required'),
    box_width: Yup.number()
      .typeError('Width must be a number')
      .positive('Width must be greater than 0')
      .required('Width is required'),
    box_height: Yup.number()
      .typeError('Height must be a number')
      .positive('Height must be greater than 0')
      .required('Height is required')
  });
  const schema = Yup.object().shape({
    items: Yup.array().of(dimensionSchema).nullable(),
    driver: Yup.string()
    .required("กรุณาระบุเลขบาร์โค้ด"),
    awbCode: Yup.string()
        .required("กรุณาระบุเลขบาร์โค้ด")
        // .min(16, 'ความยาวของบาร์โค้ดควรเป็น 16')
        // .max(16, 'ความยาวของบาร์โค้ดควรเป็น 16'),
  });
  const [shipmentStatus, setShipmentStatus] = useState("20");
  const [perPage, setPageSize] = useState(10);
  const [data, setData] = useState([]);
  const [page, setPage] = useState({
    current_page: 0,
    last_page: 1,
    total: 0,
  });
  const [pageNo, setCurrentPage] = useState(1);
  const [loading, Loading] = useState(0);
  const [errorMassNoData, setErrorMassNoData] = useState(0);

  const [listDimensions,SetListDimensions]= useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [errorMassNoData2, SetErrorMassNoData2] = useState(0);

  const [disableSubmit, setDisableSubmit] = useState(false);
  const [priceLoading, setPriceLoading] = useState(false);
  const [listDriver, setListDriver]= useState([]);
  const [driver,setDriver]=useState("");

  const [show, setShow] = useState(false);
  const handleClose = () => {
    SetListDimensions([]);
    setShow(false);
  }
  const handleShow = () => {
    setShow(true);
    setTimeout(() => {
      if (inputsRef.current[0]) {
        inputsRef.current[0].focus();
        inputsRef.current[0].select();
      }
    }, 10);
    setActiveTab(0);
  }
  const [barcodeNumber, BarcodeNumber] = useState("");
  

  useEffect(() => {
    fetchData({
      shipmentStatus: shipmentStatus,
      empCode: user.username,
      pageNo: pageNo,
      perPage: perPage,
    });
    fetchListDriver();
  }, []);

  useEffect(() => {
    if (show && inputsRef.current[0]) {
      setTimeout(() => {
        inputsRef.current[0]?.focus();
        inputsRef.current[0]?.select();
      }, 100);
    }
  }, [show]);


    async function fetchListDriver() {
      let criteria = {
        keyword: "",
        roleType: "5",
        pageNo: 1,
        perPage: 2000,
      };
  
      Loading(1);
      const res = await ShowEmpService(criteria);
      // alert(res.numRowsAll>0)
      if (res.numRowsAll > 0) {
        // alert("tafa");
        setListDriver(res.result);
        // console.log(res.result);
        // setErrorMassNoData2(0);
        // alert(JSON.stringify(res.result))
        Loading(0);
      } else {
        // setErrorMassNoData2(1);
        Loading(0);
      }
    }
    

  async function fetchData(params) {
    Loading(1);
    let res = await GetData(params);
    if (res.numRowsAll > 0) {
      // const dataMerged = 
      // alert(res.result.map(item1 => ({ ...item1, ...res.sizes.find(item2 => item2.awb_code === item1.awb_code) })))
      // setData(res.result.map(item1 => ({ ...item1, ...res.sizes.find(item2 => item2.awb_code === item1.AWB_CODE) })));
      setData(res.result);
      setPage({
        current_page: res.pageNo,
        last_page: res.maxPage,
        total: res.numRowsAll,
      });
      setErrorMassNoData(0);
      Loading(0);
    } else {
      setCurrentPage(1);
      setPage({
        current_page: 1,
        last_page: 1,
        total: 0,
      });
      setErrorMassNoData(1);
      Loading(0);
    }
  }

  const handleChangeShipmentStatus = (e) => {
    setData([]);
    setErrorMassNoData([])
    setShipmentStatus(e);
    fetchData({
      shipmentStatus: e,
      empCode: user.username,
      pageNo: pageNo,
      perPage: perPage,
    });
  };

  const handleChangePageSize = (e) => {
    setData([]);
    setErrorMassNoData([])
    setPageSize(e);
    fetchData({
      shipmentStatus: shipmentStatus,
      empCode: user.username,
      pageNo: pageNo,
      perPage: e,
    });
  };

  const handleChangePage = (e, newPage) => {
    setData([]);
    setErrorMassNoData([])
    setCurrentPage(newPage);
    fetchData({
      shipmentStatus: shipmentStatus,
      empCode: user.username,
      pageNo: newPage,
      perPage: perPage,
    });
  };
  const { t } = useTranslation();

  async function insertData(params) {
    console.log("params", params)
      try {
        let result = await InsertData2(params);
        if (result.status === 0) {
          swalError();
        } else {
          setData([]);
          setErrorMassNoData([])
          fetchData({
            shipmentStatus: shipmentStatus,
            empCode: user.username,
            pageNo: pageNo,
            perPage: perPage,
          });
      }
    }
    catch (e) {
      swalError({
        text: t(e.response.data.message),
      });
    }
  }

  return (
    <>
      <Formik
        validationSchema={schema}
        initialValues={{
          awbCode: "",
          shipmentStatus: shipmentStatus,
          empCode: user.username,
          items: listDimensions,
          driver: driver
        }}
        onSubmit={async (value, { setFieldValue }) => {
          value.empCode = user.username;
          value.driver= driver;
          insertData(value);
          value.awbCode = "";
          document.getElementById("awbCode").value = "";
          handleClose();
          // Loading(0);
        }}
      >
        {({ handleSubmit,errors, touched, handleBlur, setFieldValue, values }) => (
          <Form>
            <div className="card mb-5">
              <div className="card-body">
                <div className="container-fluid mt-2 mb-2">
                  <div className="text-center text-title-color">
                    <h2>{t('mis.sixWheel.title')}</h2>
                  </div>
                  <br />
                  <div className="row ">
                    <div className="col-12 col-md-3">
                      {" "}
                      <div className="form-group ">
                        <label>{t('mis.sixWheel.status')}</label>
                        <br />
                        <div className="form-check form-check-inline ">
                          <input
                            style={{ width: "20px", height: "20px" }}
                            className="form-check-input"
                            type="radio"
                            name="shipment_status"
                            id="shipment_status1"
                            defaultValue="20"
                            checked={shipmentStatus === "20" ? true : false}
                            onChange={(e) => {
                              setFieldValue("shipmentStatus", e.target.value);
                              handleChangeShipmentStatus(e.target.value);
                            }}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="shipment_status1"
                          >
                            1. {t('mis.sixWheel.loaded')}
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-3">
                      <label>{t('mis.sixWheel.driver.list.label')}</label>
                      <Typeahead
                        defaultSelected={listDriver.filter((a) => a.username === values.driver)}
                        id="emp_code"
                        name="emp_code"
                        labelKey={(option) => `${option.username}`}
                        onChange={(e) => {
                          if (e.length > 0) {
                            let value = e[0].username;
                            // alert(value);
                            setFieldValue('driver', value);
                            setDriver(value);
                          }
                        }}
                        onInputChange={(text, e) => {
                          setFieldValue('driver', '');
                        }}
                        options={listDriver}
                        placeholder={"-- "+t('mis.sixWheel.placeholder')+" --"}
                        selected={values.driver === '' ? [] : listDriver.filter((a) => a.username === values.driver)}
                        inputProps={{
                          className:
                            "form-control " +
                            (touched.driver
                              ? errors.driver
                                ? "is-invalid"
                                : "is-valid"
                              : ""),
                        }}
                      />
                    </div>
                    <div className="col-12 col-md-4">
                      <div className="form-group">
                        <label htmlFor="awbCode">{t('mis.sixWheel.field.awbCode')}</label>
                        <input
                          value={values.awbCode}
                          type="text"
                          name="awbCode"
                          id="awbCode"
                          onBlur={handleBlur}
                          className={
                            "form-control " +
                            (getIn(touched, "awbCode")
                              ? getIn(errors, "awbCode")
                                ? "is-invalid"
                                : "is-valid"
                              : "") +
                            ""
                          }
                          autoComplete="offf"
                          onChange={(e) => {
                            setFieldValue("awbCode", e.target.value);
                          }}
                        />
                        <ErrorMessage
                          component="div"
                          name="awbCode"
                          className="invalid-feedback"
                        />
                      </div>
                    </div>
                    <div className="col-12 col-md-1 text-center mt-2">
                      <div className="form-group mt-4 ">
                        <button 
                          className="btn btn-success" 
                          type="submit"
                          // onClick={(e)=>{
                          //   // handleShow()
                          // }}
                        >
                          {t('mis.sixWheel.form.record')}
                        </button>
                      </div>
                    </div>
                  </div>

                  <hr className="mt-4 mb-4" />
                  <h4>{t('mis.sixWheel.scanningHistory')}</h4>
                  <FilterData
                    perPage={perPage}
                    handleChangePageSize={handleChangePageSize}
                  />
                  <ShowData
                    data={data}
                    page={page}
                    loading={loading}
                    errorMassNoData={errorMassNoData}
                    pageNo={pageNo}
                    handleChangePage={handleChangePage}
                    perPage={perPage}
                  />
                </div>
              </div>
            </div>



          </Form>
        )}
      </Formik>
    </>
  );
}

const mapStateToProps = (state) => ({
  user: state.Authentication,
});

export default connect(mapStateToProps)(SixWheelScan);
